﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListLog extends GuiListGeneric {

    constructor() {
        super("Log");
    }
}
